/** Default brand name in the feed preview when scope is global. */
export const DEFAULT_PREVIEW_BRAND = 'Zara';

export const OFFER_FEED_PREVIEW_COPY = {
  asideAria: 'Shoppers tile preview',
  eyebrow: 'Shopper tile',
  heading: 'Feed preview',
  sub: `Same layout as the app product card: sale pill, wishlist, brand mark, rating strip, price row, then offer bar with countdown when the rule has an end time.`,
} as const;

export const BRAND_SCOPE_DROPDOWN_COPY = {
  placeholder: 'Select brand',
  searchPlaceholder: 'Search brand',
  listboxAria: 'Choose brand',
  empty: 'No brands match.',
} as const;

export const BRAND_OFFER_FORM_COPY = {
  drawerEyebrowEdit: 'Edit offer',
  drawerEyebrowCreate: 'Create offer',
  drawerTitleEdit: 'Update configuration',
  drawerTitleCreate: 'New pricing rule',
  drawerSubtitle:
    'Fields on the left; shopper-facing tile on the right updates as you type.',
  closeDrawerAria: 'Close drawer',
  sectionIdentity: 'Identity',
  offerTypesLabel: 'Offer types',
  offerTypesRadiogroupAria: 'Offer types',
  offerNameLabel: 'Offer name',
  offerNamePlaceholder: 'Monsoon flat 20 — Zara',
  rankLabel: 'Rank (higher wins)',
  rankPlaceholder: '10',
  brandLabel: 'Brand',
  brandIdPlaceholder: 'Brand id',
  sectionTimeWindow: 'Time window',
  startsAtLabel: 'Starts at (optional)',
  startsAtHint: 'Leave blank to go live as soon as the offer is toggled on.',
  endsAtLabel: 'Ends at',
  sectionDiscount: 'Discount',
  discountTypeLabel: 'Type',
  discountTypeGroupAria: 'Discount type',
  discountFlatPill: 'Flat (₹)',
  discountPercentPill: 'Percentage',
  discountValueLabel: 'Value',
  discountValueHintPercent: '0–100',
  discountValueHintInr: 'INR',
  discountValuePlaceholderPercent: '15',
  discountValuePlaceholderFlat: '500',
  sectionOnTileCopy: 'On-tile copy',
  discountTextLabel: 'Line shoppers read',
  discountTextPlaceholder: 'Extra 5–10% off at checkout',
  sectionShopperLine: 'Shopper line',
  suffixTextLabel: 'Suffix text',
  suffixTextPlaceholder: 'flat 50% off with code SLAYD',
  shopperLineHintBeforeStrong: 'The tile auto-leads with ',
  shopperLineHintStrong: 'Get at ₹X',
  shopperLineHintAfterStrong:
    '. This text appears right after — keep it short. Override the prefix by including ',
  shopperLineHintToken: '{discount_price}',
  shopperLineHintTail: ' in your copy.',
  sectionCartTiers: 'Cart tiers',
  tierHintPerTierType:
    'Cart bands are in ₹. Each tier can be flat ₹ off or % off.',
  addTier: 'Add tier',
  tierHeadMin: 'Min ₹',
  tierHeadMax: 'Max ₹',
  tierHeadDiscountType: 'Type',
  tierHeadAmount: 'Amount',
  tierDiscountTypeGroupAria: 'Discount type for tier',
  tierPlaceholderMin: '0',
  tierPlaceholderMax: '∞',
  tierPlaceholderValueRupee: '300',
  tierPlaceholderValuePercent: '10',
  bannerTemplateLabel: 'Banner text template',
  bannerTemplateHint1: 'Pick how the saving shows on the tile. ',
  bannerTemplateHint2:
    " is replaced by the tier's discount — so each product shows its own amount.",
  onSaleLabel: 'On sale',
  onSaleHintLocked:
    'Always on for sale and sale + extra — shows the Sale live pill on the tile.',
  onSaleHintOptional:
    'Optional — turn on to show the Sale live pill on the tile.',
  showTimerLabel: 'Show countdown timer',
  showTimerHint:
    'Renders a live countdown on the tile. Uses the end date and time above.',
  liveOnAppLabel: 'Live on app',
  liveOnAppHint: 'Paused rules stay in the list but never surface in the app.',
  footerDiscard: 'Discard',
  footerSaving: 'Saving…',
  footerSaveUpdates: 'Save updates',
  footerPublish: 'Publish offer',
  toastUpdated: 'Offer updated.',
  toastPublished: 'Offer published.',
  toastSaveFailed: 'Save did not go through. Retry.',
  previewBrandFallback: 'Brand',
} as const;

export function removeTierRuleAriaLabel(zeroBasedIndex: number): string {
  return `Remove tier ${zeroBasedIndex + 1}`;
}

export function formatTierTemplateExample(preview: string): string {
  return `e.g. "${preview}"`;
}
